import React from 'react';
import { HorizontalBar, Bar, Doughnut } from 'react-chartjs-2';
import 'chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes';
import { OrangeGold20 as oldScheme, Tableau20 as currentScheme } from 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.tableau';
import { Container, Col, Row} from 'reactstrap';
import hexOpacity from  'hex-opacity';

const generateDataObject = ({ dataArray = [], labelsArray = [], colorsLight = [], colorsDark = [] }) => ({
  labels: labelsArray,
  datasets: [{
    data: dataArray,
    backgroundColor: colorsLight,
    borderColor: colorsDark,
    hoverBackgroundColor: colorsDark,
    hoverBorderColor: colorsDark,
  }],
});

export default function ({ skills = [], isHorizontal }) {
  const [data, setData] = React.useState({});

  React.useEffect(() => {
    if (skills) {
      let colorsDark = skills.map((_, index) => currentScheme[index%currentScheme.length]);
      let colorsLight = colorsDark.map(item => hexOpacity.create(item, 0.8));
      setData(generateDataObject({
        dataArray: skills.map((item) => Math.round(6 + Math.random()*2)),
        labelsArray: [...skills],
        colorsLight,
        colorsDark,
      }));
    }
  }, [skills]);

  return (
    <Container 
      styles={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        maxWidth: '500px',
      }}
    >
      {/* <h2>Doughnut Chart</h2> */}
      {
        isHorizontal ? 
        (
          <HorizontalBar 
            data={data} 
            options={{
              plugins: {
                colorschemes: {
                  scheme: currentScheme,
                },
              },
              legend: {
                display: false,
              },
              scales: {
                xAxes: [{
                  categoryPercentage: 0.5,
                  barPercentage: 1.0,
                  ticks: {
                    min: 0,
                    max: 10,
                  }
                }]
              }
            }}
          />
        ) : 
        (
          <Bar
            data={data}
            height={400} 
            options={{
              plugins: {
                colorschemes: {
                  scheme: currentScheme,
                },
              },
              legend: {
                display: false,
              },
              scales: {
                yAxes: [{
                  ticks: {
                    min: 0,
                    max: 10,
                  }
                }]
              }
            }}
          />
        )
      }
    </Container>
  );
}
